import * as d3 from 'd3-selection';

/**
 A d3 chart axis label.
 @param {Object} selection - The selection.
 @param {Function} xScale - The x scale.
 @param {Function} yScale - The y scale.
 */
function chartAxisLabel(selection, xScale, yScale) {
  selection.each(function render(props) {
    const chartWidth = xScale.range()[1];
    const chartHeight = yScale.range()[0];
    const {
      orient,
      grid = true,
      label = '',
      labelPadding = 6,
    } = props[0];
    const otherOrient = props[1];

    let transform;
    if (orient === 'top' && grid) {
      transform = 'translate(0,0)';
    } else if (orient === 'bottom' && grid) {
      transform = `translate(0,${chartHeight})`;
    } else if (orient === 'top') {
      transform = 'translate(0,0)';
    } else if (orient === 'bottom') {
      transform = `translate(0,${chartHeight})`;
    } else if (orient === 'right' && grid) {
      transform = `translate(${chartWidth},0)`;
    } else if (orient === 'left' && grid) {
      transform = 'translate(0,0)';
    } else if (orient === 'right') {
      transform = `translate(${chartWidth},0)`;
    } else {
      transform = 'translate(0,0)';
    }

    if (otherOrient === 'right') {
      d3.select(this)
        .text(label)
        .attr('transform', transform)
        .attr('text-anchor', 'start')
        .attr('dx', labelPadding)
        .attr('y', orient === 'top'
          ? labelPadding
          : -labelPadding)
        .attr('dominant-baseline', orient === 'top'
          ? 'hanging'
          : 'auto');
    } else if (otherOrient === 'left') {
      transform = transform.replace('(0', `(${chartWidth}`);
      d3.select(this)
        .text(label)
        .attr('transform', transform)
        .attr('text-anchor', 'end')
        .attr('dx', -labelPadding)
        .attr('y', orient === 'top'
          ? labelPadding
          : -labelPadding)
        .attr('dominant-baseline', orient === 'top'
          ? 'hanging'
          : 'auto');
    } else if (otherOrient === 'top') {
      transform = transform.replace('0)', `${chartHeight})`);
      d3.select(this)
        .text(label)
        .attr('transform', `${transform},rotate(90)`)
        .attr('text-anchor', 'end')
        .attr('dx', labelPadding)
        .attr('y', orient === 'right'
          ? labelPadding
          : -labelPadding)
        .attr('dominant-baseline', orient === 'right'
          ? 'hanging'
          : 'auto');
    } else {
      d3.select(this)
        .text(label)
        .attr('transform', `${transform},rotate(-90)`)
        .attr('text-anchor', 'end')
        .attr('dx', -labelPadding)
        .attr('y', orient === 'right'
          ? -labelPadding
          : labelPadding)
        .attr('dominant-baseline', orient === 'right'
          ? 'auto'
          : 'hanging');
    }
  });

  selection.raise();
}

export default chartAxisLabel;
